import {
  LoadingSpinner,
  Modal,
  ModalWidth,
  Typography,
  TypographyFont,
  TypographySize,
  TypographyWeight
} from '../../../../core';
import { JsonViewer } from '../../../../shared/JsonViewer';

import { ApiActionStepExecutionInfo } from '~/hooks/useExecuteApiActionStep';

interface WorkflowApiActionStepTestModalProps {
  executionInfo: ApiActionStepExecutionInfo | null;
  isLoading: boolean;
  onClose: () => void;
}

const WorkflowApiActionStepTestModal: React.FC<
  WorkflowApiActionStepTestModalProps
> = ({ onClose, isLoading, executionInfo }) => (
  <Modal onClose={onClose} open width={ModalWidth.NINE_TWENTY}>
    <div className="flex flex-col gap-8" data-testid="api-test-modal-content">
      <Typography
        font={TypographyFont.HEADING}
        size={TypographySize.H3}
        weight={TypographyWeight.SEMI_BOLD}
      >
        API Test Results
      </Typography>
      {isLoading ? (
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      ) : (
        executionInfo && (
          <div
            className="flex flex-col gap-6"
            data-testid="api-test-results-container"
          >
            <JsonViewer data={executionInfo.request} title="Request" />
            <JsonViewer data={executionInfo.response} title="Response" />
          </div>
        )
      )}
    </div>
  </Modal>
);

export default WorkflowApiActionStepTestModal;
